import { Box, Typography } from '@mui/material';
import { tokens } from '../theme';
import BlurText from '../reactbits/BlurText';

export default function Mission() {
  return (
    <Box component="section" id="mission" sx={{ bgcolor: tokens.pine, py: { xs: 8, md: 12.5 }, px: 3 }}>
      <Box
        sx={{
          maxWidth: 1080,
          mx: 'auto',
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '0.9fr 1.3fr' },
          gap: { xs: 4, md: 8 },
          alignItems: 'start',
        }}
      >
        <Box>
          <Typography sx={{ fontFamily: tokens.mono, fontSize: '0.72rem', letterSpacing: '0.14em', textTransform: 'uppercase', color: tokens.frost, mb: 2.25 }}>
            The idea
          </Typography>
          <BlurText
            text="From research prototype to climate technology"
            delay={30}
            style={{
              fontFamily: tokens.display,
              fontWeight: 500,
              fontSize: 'clamp(1.8rem, 4vw, 2.6rem)',
              lineHeight: 1.2,
              color: tokens.paper,
            }}
          />
        </Box>

        <Box>
          <Typography sx={{ fontSize: '1.02rem', lineHeight: 1.75, color: tokens.paperDim, mb: 2 }}>
            Climate-driven disasters are accelerating, yet most remote regions still have no way to see them coming.
            EWAS is an AI-powered early warning platform built at LUMS, combining edge AI, computer vision, IoT
            sensing, and remote sensing to keep watch over places conventional infrastructure can&apos;t reach.
          </Typography>
          <Typography sx={{ fontSize: '1.02rem', lineHeight: 1.75, color: tokens.paperDim, mb: 2 }}>
            A single low-cost, solar-powered platform — the same hardware, running different models — adapts to
            what a landscape needs to be protected from, whether that&apos;s a spreading fire or a moment of
            conflict between people and the wildlife they share the land with.
          </Typography>
          <Typography sx={{ fontSize: '1.02rem', lineHeight: 1.75, color: tokens.paperDim }}>
            We&apos;re currently working with research, government, and conservation partners across Pakistan, and
            preparing to open the platform more broadly.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
